/* tslint:disable */
/* eslint-disable */
/**
 * RaidSIMP OpenAPI Spec
 * Manage your raid teams, enhanced with data from the Blizzard API.
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminIlvlThresholdDto
 */
export interface AdminIlvlThresholdDto {
    /**
     * Minimum item level for this color.
     * @type {number}
     * @memberof AdminIlvlThresholdDto
     */
    ilvl: number;
    /**
     * Hex color, e.g. #a335ee.
     * @type {string}
     * @memberof AdminIlvlThresholdDto
     */
    color: string;
    /**
     * Item rarity this color belongs to, e.g. Epic.
     * @type {string}
     * @memberof AdminIlvlThresholdDto
     */
    rarity: string;
    /**
     * What the threshold stands for.
     * @type {string}
     * @memberof AdminIlvlThresholdDto
     */
    description: string;
}

export function AdminIlvlThresholdDtoFromJSON(json: any): AdminIlvlThresholdDto {
    return AdminIlvlThresholdDtoFromJSONTyped(json, false);
}

export function AdminIlvlThresholdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminIlvlThresholdDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ilvl': json['ilvl'],
        'color': json['color'],
        'rarity': json['rarity'],
        'description': json['description'],
    };
}

export function AdminIlvlThresholdDtoToJSON(value?: AdminIlvlThresholdDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ilvl': value.ilvl,
        'color': value.color,
        'rarity': value.rarity,
        'description': value.description,
    };
}


